import { render, staticRenderFns } from "./Islands.vue?vue&type=template&id=2c604e33&scoped=true"
import script from "./Islands.vue?vue&type=script&lang=js"
export * from "./Islands.vue?vue&type=script&lang=js"
import style0 from "./Islands.vue?vue&type=style&index=0&id=2c604e33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c604e33",
  null
  
)

export default component.exports